import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const OPTS = {
  en: [["sda", "Seventh-day Adventist"], ["nondenom", "Non-denominational"], ["baptist", "Baptist"], ["catholic", "Catholic"],
    ["pentecostal", "Pentecostal"], ["other", "Other"], ["none", "Not affiliated with a church"], ["private", "Prefer not to say"]],
  es: [["sda", "Adventista del Séptimo Día"], ["nondenom", "No denominacional"], ["baptist", "Bautista"], ["catholic", "Católica"],
    ["pentecostal", "Pentecostal"], ["other", "Otra"], ["none", "No pertenezco a una iglesia"], ["private", "Prefiero no decirlo"]],
};

export const VolunteerAffiliation = ({ info, setInfo, lang }) => {
  const es = lang === "es";
  return (
    <div className="space-y-2" data-testid="volunteer-affiliation-field">
      <Label htmlFor="v-aff">{es ? "¿Cuál es tu afiliación religiosa?" : "What is your religious affiliation?"} <span className="text-muted-ink font-normal">{es ? "(opcional)" : "(optional)"}</span></Label>
      <select id="v-aff" value={info.affiliation || ""} onChange={(e) => setInfo({ ...info, affiliation: e.target.value, affiliation_other: "" })}
        className="w-full h-12 rounded-lg border border-line bg-white px-3 text-navy" data-testid="assess-affiliation-select">
        <option value="">{es ? "Selecciona una opción" : "Select an option"}</option>
        {OPTS[es ? "es" : "en"].map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {info.affiliation === "other" && <Input value={info.affiliation_other || ""} maxLength={60} onChange={(e) => setInfo({ ...info, affiliation_other: e.target.value })}
        placeholder={es ? "Escribe tu afiliación" : "Type your affiliation"} className="h-12" data-testid="assess-affiliation-other-input" />}
    </div>
  );
};
